export default __webpack_public_path__ + "static/media/U_Forms.8fb5178b.png";